const lightTheme = {
    background: '#ffffff',
    textPrimary: '#000000',
    textSecondary: '#4B5563',
};

const darkTheme = {
    background: '#2c3e50',
    text: '#ffffff',
    primary: '#3498db',
};

const themes = {
    lightTheme: lightTheme,
    darkTheme: darkTheme
}

export default themes;